import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import { useState, useEffect, useRef } from "react";
import api from "../../api";
import { checkPermissionStatus } from "helpers/utils";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { Trans, useTranslation } from "react-i18next";

const VacancyTypeList = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const fetchVacancyTypeList = () => {
    const lang_id =
      localStorage.getItem("lang_id") !== "1"
        ? localStorage.getItem("lang_id")
        : "1";
    console.log(lang_id, "lang_id");
    GetVacancyTypeList(lang_id)
      .then(res => {
        let response = decryptDataFromArray(res.data);

        if (response.status) {
          setData(response.data);
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
  };

  useEffect(() => {
    fetchVacancyTypeList();
  }, []);

  //Bootstrap table columns
  let columns = [
    {
      dataField: "title",
      text: t(`vacancy_type.VacancyTypeTitle`),
    },
    {
      dataField: "description",
      text: t(`vacancy_type.Description`),
      classes: "white-hidden",
    },
    {
      dataField: "status",
      text: t(`vacancy_type.Status`),
      formatter: (cell, row) => {
        // return cell === 1 ? t(`vacancy_type.Status`) : t(`vacancy_type.Status`);
        return t(`vacancy_type.Status`);
      },
    },
    {
      dataField: "sequence",
      text: t(`vacancy_type.Sequence`),
    },
  ];

  if (checkPermissionStatus("job-list", "edit")) {
    columns.push({
      dataField: "id",
      text: t(`vacancy_type.Actions`),
      formatter: cell => {
        return (
          <div className="d-flex gap-2 blue-icon-gap">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-vacancyType/${cell}`}
                title={t(`vacancy_type.EditVacancyType`)}
              >
                {/* <i
                  className="mdi mdi-pencil-outline font-size-18"
                  id="logintooltip"
                  style={{ color: "black" }}
                ></i> */}
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`vacancy_type.Edit`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                className="text-success blue-icon blue-color3"
                onClick={() => handleVacancyTypeDelete(cell)}
                style={{ cursor: "pointer" }}
                title={t(`vacancy_type.Delete vacancy Type`)}
              >
                {/* <i
                  className="mdi mdi-trash-can font-size-18"
                  style={{ color: "black" }}
                ></i> */}
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`vacancy_type.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = data.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (data.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [data.length]);

  //Delete Reclords

  const handleVacancyTypeDelete = vacancyId => {
    if (window.confirm(t(`vacancy_type.DeleteAlert`))) {
      api
        .delete(
          `${process.env.REACT_APP_API_URL}/admin/vacancyType/delete-vacancyType/${vacancyId}`
        )
        .then(response => {
          let { success } = response.data;
          if (success) {
            fetchVacancyTypeList();
          }
        })
        .catch(err => {});
    }
  };

 
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  /**table arrow */
  const tableWrapperRef1 = useRef(null);
  const handleScroll1 = direction => {
    if (tableWrapperRef1.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef1.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
   if (!checkPermissionStatus("job-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`vacancy_type.Access Denied`)}</h4>
      </div>
    );
  }

  ///////////
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="joblist-container create-vacancy">
            <Row className="mb-3 align-items-center">
              <Col lg="6" md="6">
                <Link to="/job-list">
                  <h5 className="text-uppercase heading-one mb-2">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`vacancy_type.VacancyTypeList`)}{" "}
                  </h5>
                </Link>
              </Col>

              <Col lg="6" md="6">
                <div class="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                  {checkPermissionStatus("job-list", "create") && (
                    <Link to="/create-vacancyType" className="btn btn-primary">
                      {t(`vacancy_type.CreateVacancyType`)}
                    </Link>
                  )}
                  <div className="tale-text right-panel vacancytypelist mobile-arrow m-0">
                    <button
                      className="button left"
                      onClick={() => handleScroll1("left")}
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                    <button
                      className="button right"
                      onClick={() => handleScroll1("right")}
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {successMessage && (
            <div class="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}
          <div className="outerTab-box-wrapper  toolkitproviders">
            <div className="timeto-hire-card userlist ">
              <div className="tabel-application tabel-application-auto table-responsive white-space-row">
                <ToolkitProvider
                  keyField="head1"
                  data={data}
                  columns={columns}
                  search
                >
                  {props => (
                    <div className="table-custome-class range-custome">
                      <>
                        <div className="scroll-container">
                          <div className="table-pending-list">
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef1}
                            >
                              <BootstrapTable
                                {...props.baseProps}
                                pagination={paginationFactory(options)}
                                options={options}
                                striped
                                rowClasses={rowClasses}
                                hover
                                responsive
                                wrapperClasses="table-wrapper"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default VacancyTypeList;
